/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

export const EShapeLayerState = {
	INVISIBLE: "INVISIBLE", // Invisible initially when non-edit mode
	INTERACTIVE: "INTERACTIVE",
	DRAGGABLE: "DRAGGABLE",
	PINCHABLE: "PINCHABLE"
};
